import { IContextualMenuProps, CommandButton, CompoundButton, Dialog, DialogContent, DialogType, DialogFooter } from '@fluentui/react';
import React from 'react';
import App from '../../App';
import { IUserService, Services } from '../../services';
import styles from './AppLayout.module.scss';
import { AnnouncementMessageBar } from './AnnouncementMessageBar';
import { UserServiceProvider } from '../../services/userService';

interface IAppLayoutProps {

}

interface IAppLayoutState {
  showIntro: boolean;
}

export class AppLayout extends React.Component<IAppLayoutProps, IAppLayoutState> {
  private userService: IUserService;

  constructor(props: IAppLayoutProps) {
    super(props);

    this.userService = Services.UserService.Initialize(new UserServiceProvider());

    this.state =
    {
      showIntro: this.userService.IsFirstTimeForUser()
    }
  }

  public render(): React.ReactElement<{}> {
    let userMenuProps: IContextualMenuProps = {
      items: [
        {
          key: 'changePassword',
          text: 'Skift adgangskode',
          iconProps: { iconName: 'PasswordField' },
          href: "/skift-adgangskode"
        },
        {
          key: 'signOut',
          text: 'Log af',
          iconProps: { iconName: 'SignOut' },
          onClick: (ev) => {
            this.userService.SignOut();
          }
        },
      ]
    };

  if (App.IsUserInRole("DL") || App.IsUserInRole("Purchaser") || App.IsUserInRole("Admin")) {
      userMenuProps.items.splice(1, 0, {
        key: 'assignments',
        text: 'Opgaveoversigt',
        iconProps: { iconName: 'TaskManager' },
        href: "/"
      });

      userMenuProps.items.splice(2, 0, {
        key: 'userAdministration',
        text: 'Brugeradministration',
        iconProps: { iconName: 'Contact' },
        href: "/brugeradministration"
      });

      // Only show 'Information til DL'ere' for DL role
      if (App.IsUserInRole("DL")) {
        userMenuProps.items.splice(3, 0, {
          key: 'linkInfoPageInternally',
          text: 'Information til DL`ere',
          iconProps: { iconName: 'BookAnswers' },
          href: "https://ddh4.sharepoint.com/sites/Intranet/SitePages/Flisportalen.aspx",
          target: "_blank"
        });
      }
    }

    if (App.IsUserInRole("Admin")) {
      userMenuProps.items.splice(4, 0, {
        key: 'announcements',
        text: 'Beskeder',
        iconProps: { iconName: 'Message' },
        href: "/beskeder"
      });
    }

    return (
      <div className={styles.layoutContainer}>
        <div className={styles.header}>
          <div className={styles.headerContent}>

            <a href="/" className={styles.logoContainer}><img alt="Dalgas logo" className={styles.logo} style={{ padding: 15 }} src="/images/ds-logo-wide-RGB-neg.png?rev=1.0" /></a>
            {App.IsAuthenticated &&
              <React.Fragment>
                <CommandButton className={styles.userMenu} text={App.Username} menuProps={userMenuProps} />

                {this.state.showIntro &&

                  <Dialog hidden={false} minWidth={window.innerWidth * 0.6} dialogContentProps={{ title: "Flisleverandør til Dalgas", isMultiline: true, type: DialogType.largeHeader }}>
                    <DialogContent>
                      <div>
                        <h4>Intro</h4>

                        <div>I Danmark har vi indført lovgivning om bæredygtighed af flis til energi. Det betyder at leverandører af flis skal dokumentere, at produktionen er foregået efter de gældende bæredygtighedsregler. Dalgas bruger certificeringsordningen SBP til at dokumentere bæredygtigheden af vores flisleverancer.
                          Når du sælger flis eller flistræ til Dalgas, vil du blive bedt om at overholde nogle regler og aflevere noget information til os, så vi kan tage dine leverancer ind under vores SBP-certificering.
                          Alle der arbejder på en opgave skal have gennemført Dalgas online SBP-kursus. Din Dalgas skovfoged eller driftsleder kan hjælpe dig med at få adgang til kurset.</div>
                        <br />
                        <h4>Dokumentation</h4>
                        <div>
                          <ul>
                            <li>Kort 1 som viser hvilke naturhensyn og kulturminder, der findes i det relevante produktionsområde.</li>
                            <li>Kort 2 som viser HNV-status på produktionsområdet.</li>
                          </ul>
                          <p>De to kort skal laves før fældearbejdet begynder og skal være tilgængelige for alle der udfører arbejde på opgaven. Bæredygtighedsdokumentationen skal udfyldes, før du overdrager flisen til Dalgas.</p>
                        </div>
                      </div>
                    </DialogContent>
                    <DialogFooter>
                      <CompoundButton iconProps={{ iconName: "Help" }} secondaryText="Gå til supportportalen" onClick={() => { this.onDismissFirstTimeIntro(); window.open('https://flisportal-support.azurewebsites.net', '_blank'); }}>Behov for hjælp?</CompoundButton>
                      <CompoundButton primary iconProps={{ iconName: "CheckMark" }} secondaryText="Begynd at bruge Flisportalen" onClick={() => { this.onDismissFirstTimeIntro(); }}>Jeg har forstået</CompoundButton>
                    </DialogFooter>
                  </Dialog>
                }
              </React.Fragment>
            }

          </div>
        </div>
        <div className={styles.container}>
          {App.IsAuthenticated && <AnnouncementMessageBar />}

          <div className={styles.headerimage}>
            <img alt="Dalgas Flis baggrund" src="/images/topbanner.jpg?rev=1.0" />
            <div className={styles.overlayImageContainer}>
              <div className={styles.overlayImageRow}>
                <img className={styles.fifth3} src="/images/hs-element-lavender-02-rgb.png" />
              </div>
              <div className={styles.overlayImageRow}>
                <img className={styles.fifth2} src="/images/hs-element-lavender-02-rgb.png" />
                <img className={styles.fifth1} src="/images/hs-element-lavender-01-rgb.png" />
              </div>
            </div>
          </div>
          <div className={styles.appName}>Flisportalen</div>
          <div className={styles.helpSection}>
            <CompoundButton iconProps={{ iconName: "Help" }} secondaryText="Gå til supportportalen" onClick={() => { window.open('https://flisportal-support.azurewebsites.net', '_blank'); }}>Behov for hjælp?</CompoundButton>
          </div>
          <div className={styles.contentWrapper}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }

  private onDismissFirstTimeIntro() {
    this.userService.dismissFirstTimeIntro();

    this.setState({ showIntro: false });
  }
}
